<template>
  <section class="next-steps-container">
    <header class="next-steps-header">
      <h1 class="title">Welcome to Teamwrkr!</h1>
      <p class="subtitle">Your AI-powered career profile is just getting started.</p>
    </header>

    <div class="next-steps-content">
      <div class="message-card">
        <div class="card-header">
          <span class="icon header-icon">
            <i class="mdi mdi-check-circle"></i>
          </span>
          <h2 class="header-title">Thank You for Signing Up</h2>
        </div>

        <div class="card-body">
          <p class="message-text">
            Thanks for signing up! Your Profile is ready to grow with you.
          </p>

          <p class="message-text">
            To save your progress and unlock your personalized insights, please
            <strong>verify your email</strong> and <strong>complete your profile</strong>.
          </p>

          <p class="message-text">
            Once verified, you’ll gain access to:
          </p>
          <ul>
            <li>Your <strong>AI-generated Profile</strong></li>
            <li>Access to the <strong>Teamwrkr community</strong></li>
            <li>Ongoing updates as your experience evolves</li>
          </ul>

          <div class="next-steps-list">
            <h3 class="list-title">
              <span class="icon"><i class="mdi mdi-format-list-checks"></i></span>
              Next Steps:
            </h3>

            <ol class="steps-list">
              <li class="step-item">
                <span class="step-number">1</span>
                <span class="step-text">Check your email for a <strong>verification email</strong></span>
              </li>
              <li class="step-item">
                <span class="step-number">2</span>
                <span class="step-text">Click the link to verify your email address</span>
              </li>
              <li class="step-item">
                <span class="step-number">3</span>
                <span class="step-text">Complete your profile inside Teamwrkr</span>
              </li>
              <li class="step-item">
                <span class="step-number">4</span>
                <span class="step-text">Start exploring your personalized Profile and community access</span>
              </li>
            </ol>
          </div>
        </div>

        <div class="card-footer">
          <b-button
            type="is-primary"
            icon-left="email"
            class="action-button"
            @click="resendVerificationEmail"
          >
            Resend Verification Email
          </b-button>

          <!-- <b-button
            type="is-light"
            icon-left="login"
            class="action-button"
            @click="goToVerify"
          >
            Go to Verify
          </b-button> -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { useUserStore } from '../stores/userStore'

export default {
  name: 'NextSteps',
  data() {
    return {
      isLoading: false,
      analyzeData: null,
    }
  },
  beforeCreate() {
    if (this.$cookies.get('teamwrkr-token')) {
      this.$router.push('/');
    }
  },
  created() {
    this.userStore = useUserStore()
  },
  mounted() {
    console.log('mounted next steps page', this.userStore.user);
    if (this.userStore.user) {
      this.triggerEmailSend();
    }
  },
  methods: {
    async resendVerificationEmail() {
      try {
        await this.triggerEmailSend();
        this.$buefy.toast.open({
            message: `Verification Email has been Resent to ${this.userStore.user.email}`,
            type: "is-success",
            position: "is-bottom",
        });
      } catch (error) {
        this.$buefy.toast.open({
            message: `Error Resending Verification Email to ${this.userStore.user.email}`,
            type: "is-danger",
            position: "is-bottom",
        });
      }

    },
    async triggerEmailSend() {
      console.log('Trigger email sending to:', this.userStore.user.email);
       try {
        const response = await this.axios.post(`${process.env.VUE_APP_API_URL}/users/next-steps`, {
          email: this.userStore.user.email
        });
        console.log('Verification email sent response:', response.data);
      } catch (error) {
        console.error('Error resending verification email:', error);
      // } finally {
      //   this.isLoading = false;
      }
    },

    goToVerify() {
      this.$router.push(`/verify?email=${this.userStore.user.email}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.next-steps-container {
  padding: 2rem;
  max-width: 900px;
  margin: 0 auto;
  font-family: 'Nunito', sans-serif;
}

.next-steps-header {
  text-align: center;
  margin-bottom: 2rem;

  .title {
    font-size: 2.2rem;
    font-weight: 700;
    color: $color-text;
  }

  .subtitle {
    font-size: 1.2rem;
    color: $color-text-subtle;
    margin-top: 0.5rem;
  }
}

.next-steps-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.message-card {
  width: 100%;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  padding: 0;
  overflow: hidden;
}

.card-header {
  background: linear-gradient(135deg, $color-primary, $color-primary-deep);
  padding: 2rem;
  display: flex;
  align-items: center;

  .header-icon {
    font-size: 2.5rem;
    margin-right: 1rem;
    color: white;
  }

  .header-title {
    color: white;
    font-size: 1.8rem;
    font-weight: 700;
    margin: 0;
  }
}

.card-body {
  padding: 2rem;

  .message-text {
    font-size: 1.1rem;
    line-height: 1.6;
    color: $color-text-muted;
    margin-bottom: 1.5rem;
  }
}

.next-steps-list {
  background-color: $color-surface-soft;
  border-radius: 8px;
  padding: 1.5rem;
  margin-top: 2rem;

  .list-title {
    display: flex;
    align-items: center;
    font-size: 1.3rem;
    font-weight: 700;
    color: $color-text;
    margin-bottom: 1.2rem;

    .icon {
      margin-right: 10px;
      color: $color-primary;
    }
  }
}

.steps-list {
  padding-left: 0;
  counter-reset: steps-counter;

  .step-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 1rem;
    padding-left: 0;

    .step-number {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 28px;
      height: 28px;
      background-color: $color-primary;
      color: white;
      border-radius: 50%;
      font-weight: bold;
      margin-right: 1rem;
    }

    .step-text {
      font-size: 1.1rem;
      line-height: 1.5;
      padding-top: 0.2rem;
    }
  }
}

.card-footer {
  background-color: $color-surface-soft;
  padding: 1.5rem 2rem;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1rem;

  .action-button {
    min-width: 200px;
    font-weight: 600;
    padding: 0.75rem 1.5rem;
    transition: transform 0.3s ease, box-shadow 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }
  }
}

@media screen and (max-width: 768px) {
  .card-header {
    flex-direction: column;
    text-align: center;

    .header-icon {
      margin-right: 0;
      margin-bottom: 1rem;
    }
  }

  .card-footer {
    flex-direction: column;

    .action-button {
      width: 100%;
    }
  }
}
</style>
